import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const StyledCollapse = styled(motion.div)`
    > div {
        z-index: -1;
    }
`;

type Props = {
    isOpen: boolean;
    children: ReactNode;
};

const Collapse = (props: Props) => {
    if (!props.isOpen) return null;

    return (
        <StyledCollapse
            initial={{ opacity: 0, height: 0, zIndex: -1 }}
            animate={{ opacity: 1, height: 'auto', zIndex: 1 }}
            exit={{ opacity: 0, height: 0, zIndex: -1 }}
            transition={{ duration: 0.3 }}
        >
            {props.children}
        </StyledCollapse>
    );
};

export default Collapse;
